<div class="stick-top">
  <mat-toolbar><mat-icon>sell</mat-icon> Application Tags</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/applicationTags/0">
      <mat-icon aria-label="Create a new application tag">add</mat-icon>
      Create a new application tag
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead><tr>
      <th *ngIf="auth.isCompanyAdmin()" style="width: 75px;">
        <div class="vbox">
          Company
          <micro-company-select [(companyId)]="filter.companyId" ></micro-company-select>
        </div>
      </th>
      <th><div class="vbox">Tag<input [(ngModel)]="filter.name"></div></th>
      <th><div class="vbox">Operational Status<input [(ngModel)]="filter.operationalStatus"></div></th>
      <th><div class="vbox">Description<input [(ngModel)]="filter.description"></div></th>
    </tr></thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td *ngIf="auth.isCompanyAdmin()"><micro-company-lookup [companyId]="element.companyId"></micro-company-lookup></td>
      <td><a routerLink="/applicationTags/{{element.id}}">{{element.name}}</a></td>
      <td>{{element.operationalStatus}}</td>
      <td>{{element.description}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0"><td colspan="100"><em>No results found</em></td></tr>
    </tbody>
    <tfoot><tr><td colspan="100">
      <mat-paginator #paginator (page)="reload()"></mat-paginator>
    </td></tr></tfoot>
  </table>
</div>
